import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WelcomeSearch from "components/welcome/WelcomeSearch";
import WelcomeSearchSkeleton from "components/welcome/WelcomeSearchSkeleton";
import generateId from "logic/generateId";
import { createElasticsearchQueryString } from "views/logic/queries/Query";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import Series from "views/logic/aggregationbuilder/Series";
import Pivot from "views/logic/aggregationbuilder/Pivot";
import SortConfig from "views/logic/aggregationbuilder/SortConfig";
import Direction from "views/logic/aggregationbuilder/Direction";
import HeatmapVisualizationConfig from "views/logic/aggregationbuilder/visualizations/HeatmapVisualizationConfig";
import WidgetPosition from "views/logic/widgets/WidgetPosition";
import { DEFAULT_PIVOT_LIMIT } from "views/Constants";
import useWelcomeSearch from "components/welcome/hooks/useWelcomeSearch";
import useMetricsTimeRange from "components/welcome/hooks/useMetricsTimeRange";
import usePermittedAlertsEventsStreams from "components/welcome/hooks/usePermittedAlertsEventsStreams";
const SKIP_EMPTY_VALUES = { limit: DEFAULT_PIVOT_LIMIT, skip_empty_values: true };
const priorityByAttackSurfaceWidget = (timeRange, streams, t) => ({
  title: t("welcome_metrics.priority_by_attack_surface"),
  widget: AggregationWidget.builder().id(generateId()).timerange(timeRange).query(createElasticsearchQueryString("")).streams(streams).config(
    AggregationWidgetConfig.builder().rowPivots([Pivot.createValues(["priority"], SKIP_EMPTY_VALUES)]).columnPivots([Pivot.createValues(["fields.attack_surface"], SKIP_EMPTY_VALUES)]).series([Series.forFunction("count()")]).sort([new SortConfig(SortConfig.PIVOT_TYPE, "priority", Direction.Ascending)]).visualization("heatmap").visualizationConfig(HeatmapVisualizationConfig.empty()).rollup(false).build()
  ).build()
});
const buildEntries = (timeRange, permittedAlertsEventsStreams, t) => permittedAlertsEventsStreams.length === 0 ? [] : [
  {
    ...priorityByAttackSurfaceWidget(timeRange, permittedAlertsEventsStreams, t),
    position: new WidgetPosition(1, 1, 2.5, 12)
  }
];
const HeatmapWidget = () => {
  const { t } = useTranslation("enterprise_security_app");
  const rangeSeconds = useMetricsTimeRange();
  const permittedAlertsEventsStreams = usePermittedAlertsEventsStreams();
  const timeRange = useMemo(() => ({ type: "relative", from: rangeSeconds }), [rangeSeconds]);
  const entries = useMemo(
    () => buildEntries(timeRange, permittedAlertsEventsStreams, t),
    [timeRange, permittedAlertsEventsStreams, t]
  );
  const { view } = useWelcomeSearch(entries, timeRange);
  if (permittedAlertsEventsStreams.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(WelcomeSearch, { view, loadingPlaceholder: /* @__PURE__ */ React.createElement(WelcomeSearchSkeleton, { entries }) });
};
export default HeatmapWidget;
